<script setup>
import { ref, onMounted } from "vue";
import { setMeta } from "@/utils/util";

onMounted(() => {
  document.title = "Privacy Policy";
  setMeta("description", "DevOnlineTools Privacy Policy - Learn how we protect your privacy and data");
  setMeta("keywords", "privacy policy,data protection,user privacy,DevOnlineTools privacy");
});
</script>

<template>
  <div class="tool-body">
    <h1>Privacy Policy</h1>
    <div class="content">
      <h2>English Version</h2>
      <p>Last updated: {{ new Date().toISOString().split('T')[0] }}</p>
      
      <h3>1. Introduction</h3>
      <p>Welcome to DevOnlineTools. We are committed to protecting your privacy and personal information. This Privacy Policy explains how we collect, use, and safeguard your information when you use our website.</p>

      <h3>2. Information We Collect</h3>
      <p>We collect minimal information necessary to provide our services:</p>
      <ul>
        <li>Usage Data: Information about how you use our tools</li>
        <li>Technical Data: Browser type, device information, and IP address</li>
        <li>Cookies: Small files stored on your device to improve user experience</li>
      </ul>

      <h3>3. How We Use Your Information</h3>
      <p>We use collected information to:</p>
      <ul>
        <li>Provide and maintain our services</li>
        <li>Improve user experience</li>
        <li>Monitor usage patterns and analyze trends</li>
        <li>Prevent misuse of our services</li>
      </ul>

      <h3>4. Data Security</h3>
      <p>We implement appropriate security measures to protect your information. All data processing is done client-side whenever possible.</p>

      <h3>5. Contact Us</h3>
      <p>If you have questions about this Privacy Policy, please contact us.</p>

      <h2>中文版本</h2>
      <p>最后更新日期：{{ new Date().toISOString().split('T')[0] }}</p>

      <h3>1. 简介</h3>
      <p>欢迎使用DevOnlineTools。我们致力于保护您的隐私和个人信息。本隐私政策说明了我们如何收集、使用和保护您在使用我们网站时的信息。</p>

      <h3>2. 我们收集的信息</h3>
      <p>我们仅收集提供服务所必需的信息：</p>
      <ul>
        <li>使用数据：关于您如何使用我们工具的信息</li>
        <li>技术数据：浏览器类型、设备信息和IP地址</li>
        <li>Cookie：存储在您设备上的小文件，用于改善用户体验</li>
      </ul>

      <h3>3. 我们如何使用您的信息</h3>
      <p>我们使用收集的信息来：</p>
      <ul>
        <li>提供和维护我们的服务</li>
        <li>改善用户体验</li>
        <li>监控使用模式和分析趋势</li>
        <li>防止滥用我们的服务</li>
      </ul>

      <h3>4. 数据安全</h3>
      <p>我们实施适当的安全措施来保护您的信息。在可能的情况下，所有数据处理都在客户端进行。</p>

      <h3>5. 联系我们</h3>
      <p>如果您对本隐私政策有任何疑问，请与我们联系。</p>
    </div>
  </div>
</template>

<style scoped lang="scss">
.content {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  line-height: 1.6;

  h2 {
    margin-top: 40px;
    margin-bottom: 20px;
    color: var(--el-color-primary);
  }

  h3 {
    margin-top: 30px;
    margin-bottom: 15px;
  }

  ul {
    padding-left: 20px;
    margin-bottom: 20px;
  }

  p {
    margin-bottom: 15px;
  }
}
</style>